/**
 * Which money read a company's Overview makes (api#1121).
 *
 * CASING ALONE keeps the casing routes (revenue-week, /invoices/summary/
 * dashboard) and draws exactly the page it drew before. A company with ANY
 * other money vertical reads the global routes, whose casing figures are those
 * routes' own (proved by the API for every casing tenant), plus the rest.
 *
 * A positive guard over the other verticals, never `!hasVertical('casing_running')`:
 * casing with trucking is a multi-vertical company and gets the global read.
 */
export const GLOBAL_MONEY_VERTICALS = ['trucking', 'surface_rentals', 'downhole_tools', 'pressure_testing', 'ndt_inspection', 'pipeline_facility', 'well_testing', 'well_servicing'] as const;

export const hasGlobalMoneyVertical = (hasVertical: (key: string) => boolean): boolean =>
  GLOBAL_MONEY_VERTICALS.some((v) => hasVertical(v));
